import { removeInvalidAttributeMark } from '@/core/input_controls/validationError/validationError'
import { attributeChangesRegister } from '@/core/item_assistance/unsavedDataManager'
import { getAttributeNameWithoutPostfix } from '@/core/shared'

export function copyComponent (id, image, changesRegister) {

	var area = '#' + id + '__area'
	var maxCount = parseInt($(area).attr('max-count'), 10)

	if ($(area + ' .row').children().length < maxCount || maxCount == -1) {
		var lastRow = $(area).children().last()

		var newElement = $(lastRow).children().last().clone()
		newElement = clearElementValue($(newElement))
		var newIndex = parseInt($(newElement).attr('data-attribute-index') || 0) + 1
		newElement = updateElementIndex($(newElement), newIndex, id)
		newElement = bindElementEvents($(newElement), $(area), image)
		$(lastRow).children().last().after($(newElement))
		setElementDefaultValue($(newElement))

		if (changesRegister && !image) {
			attributeChangesRegister(id)
		}
	}
}

function bindElementEvents (element, area, image) {
	$(element).find('.button_minus').bind('click', function () {
		deleteComponent($(area), $(element), image)
	})
	if ($(element).find('.file-uploader')[0]) {
		bindImageAttributeEvents($(element).find('.file-uploader')[0])
	}
	return $(element)
}

export function clearElementValue (element) {
	$(element).find('input').val('').removeClass('invalid-attribute')
	$(element).find('textarea').val('').removeClass('invalid-attribute')
	$(element).find('.image-loading-status').removeClass('fa-check fa-frown-o')
	$(element).find('.loaded-image-name').removeClass('loading-image-result')
	$(element).find('img.loaded-image').removeAttr('src')
	return $(element)
}

function setElementDefaultValue (element) {
	var area = $(element).closest('.multiple-attribute')
	if (!$(area).data('defaultData')) {
		return
	}
	var defaultInputData = $(area).data('defaultData')['input']
	var defaultSelectData = $(area).data('defaultData')['select']
	if (defaultInputData) {
		$(element).find('input.def-val').val(defaultInputData)
	}
	if (defaultSelectData) {
		$(element).find('select.def-val').val(defaultSelectData)
	}
}

export function updateElementIndex (element, index, curId) {
	$(element).attr('data-attribute-index', index)
	$(element).find('.dictionary-list').attr('id', curId + '__' + index)
	$(element).find('.select-split').not('.dictionary-list').attr('id', 'list__' + curId + '__' + index)
	$(element).find('.select').not('.dictionary-list').attr('id', 'list__' + curId + '__' + index)
	$(element).find('.textInput-split').attr('id', curId + '__' + index)
	$(element).find('.textInput').attr('id', curId + '__' + index)
	$(element).find('.textarea').attr('id', curId + '__' + index)
	$(element).find('.textarea-split').attr('id', curId + '__' + index)
	$(element).find('.file-uploader').attr('id', curId + '__' + index)
	$(element).find('.image-attribute').attr('id', curId + '__' + index)
	$(element).find('.loaded-image-name').attr('id', curId + '__' + index)
	$(element).find('.label').attr('id', 'label__' + curId + '__' + index)
	return $(element)
}

export function deleteComponent (area, element, image) {
	var id = $(area).attr('id').substring(0, $(area).attr('id').length - 6)
	removeInvalidAttributeMark('#' + $(element).find('input').attr('id'))
	removeInvalidAttributeMark('#' + $(element).find('textarea').attr('id'))

	if ($(area).children().last().children().length > 1) {
		if (element.prevObject) {
			element.prevObject[element.prevObject.length - 1].parentNode.removeChild(element.prevObject[element.prevObject.length - 1])
		} else {
			element.parentNode.removeChild(element)
		}
	} else if (image == 'image') {
		element.remove()
	} else if (image == 'image-name') {
		element.find('.loaded-image-name').removeClass('loading-image-result')
			.addClass('hidden-element').removeAttr('data-image-token')
		element.find('img.loaded-image').attr('src', '')
		element.find('.button_minus').unbind('click')
		element.find('.image-loading-status').removeClass('fa-check fa-frown-o')
	}

	$(area).find('div[data-attribute-index]').each(function (index, element) {
		updateElementIndex($(element), index, id)
	})
	attributeChangesRegister(getAttributeNameWithoutPostfix($(area).attr("id")));
}
